module.exports = __webpack_public_path__ + "img/1300382225.eb02edbc.jpg";